(() => {
  const root = document.documentElement;
  root.classList.add('ev-motion');

  let motionReady = false;
  window.setTimeout(() => {
    if (!motionReady) root.classList.remove('ev-motion');
  }, 4000);

  const ready = () => {
    const header = document.querySelector('[data-ev-header]');
    const headerGroup = document.querySelector('#header-group');
    const setHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
    const syncHeaderHeights = () => {
      if (!header || !headerGroup) return;
      root.style.setProperty('--header-height', `${header.offsetHeight}px`);
      root.style.setProperty('--header-group-height', `${headerGroup.offsetHeight}px`);
    };

    setHeader();
    syncHeaderHeights();
    window.addEventListener('scroll', setHeader, { passive: true });
    window.addEventListener('resize', syncHeaderHeights, { passive: true });
    if (headerGroup && 'ResizeObserver' in window) new ResizeObserver(syncHeaderHeights).observe(headerGroup);
    document.fonts?.ready.then(syncHeaderHeights);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = !reduceMotion && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
      : null;

    const prepareReveals = (scope = document) => {
      scope.querySelectorAll('[data-ev-reveal]:not([data-ev-prepared])').forEach((item) => {
        item.dataset.evPrepared = 'true';
        if (!observer || window.Shopify?.designMode) item.classList.add('is-visible');
        else observer.observe(item);
      });
    };

    const closeDetails = (details, restoreFocus = true) => {
      if (!details?.open) return;
      const activeWasInside = details.contains(document.activeElement);
      details.removeAttribute('open');
      if (restoreFocus && activeWasInside) details.querySelector(':scope > summary')?.focus();
    };

    document.querySelectorAll('[data-ev-close-details]').forEach((button) => {
      button.addEventListener('click', () => closeDetails(button.closest('details')));
    });

    document.querySelectorAll('.ev-mobile-nav').forEach((details) => {
      const closeButton = details.querySelector('.ev-mobile-nav__close');
      details.addEventListener('toggle', () => {
        root.classList.toggle('ev-nav-open', details.open);
        if (details.open) window.requestAnimationFrame(() => closeButton?.focus());
      });
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !details.open) return;
        const focusable = [...details.querySelectorAll('.ev-mobile-nav__panel a[href], .ev-mobile-nav__panel button:not([disabled]), .ev-mobile-nav__panel summary, .ev-mobile-nav__panel input:not([disabled])')]
          .filter((element) => element.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.ev-mobile-nav[open], .ev-search-popover[open]').forEach((details) => closeDetails(details));
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.ev-search-popover[open]').forEach((details) => {
        if (!details.contains(event.target)) closeDetails(details, false);
      });
    });

    const updateCartCount = (quantity) => {
      if (!Number.isFinite(quantity)) return;
      document.querySelectorAll('[data-ev-cart]').forEach((cartLink) => {
        cartLink.setAttribute('aria-label', `Cart with ${quantity} items`);
        const badge = cartLink.querySelector('[data-ev-cart-count]');
        if (!badge) return;
        badge.textContent = quantity;
        badge.hidden = quantity === 0;
      });
    };

    const syncCartCount = async (payload) => {
      const eventData = payload?.detail ?? payload;
      let quantity = eventData?.cart?.totalQuantity ?? eventData?.cart?.item_count ?? eventData?.item_count;
      if (!Number.isFinite(quantity)) {
        try {
          const rootUrl = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootUrl}cart.js`, { credentials: 'same-origin' });
          if (response.ok) quantity = (await response.json()).item_count;
        } catch (_) {
          return;
        }
      }
      updateCartCount(Number(quantity));
    };

    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (event.promise?.then) event.promise.then(syncCartCount).catch(() => syncCartCount());
      else syncCartCount();
    });

    document.addEventListener('shopify:section:load', (event) => {
      prepareReveals(event.target);
      syncHeaderHeights();
    });

    prepareReveals();
    motionReady = true;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
